import { Cashdesk, createDeleteCashdeskMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type DeleteCashdeskModel = ConfirmModalModel<Cashdesk, number, null>;

export const createDeleteCashdeskModel = (): DeleteCashdeskModel => {
	const deleteCashdeskMutation = createDeleteCashdeskMutation();

	const model = createConfirmModalModel({
		modalData: declareModalData<Cashdesk>(),
		mapModalData: ({ id }) => id,
		mutation: deleteCashdeskMutation,
		successMessageKey: 'delete-cashdesk.success',
	});

	return model;
};
